import { UseQueryOptions, UseQueryResult } from 'react-query/types/react/types';
import { useAPIs } from 'src/hooks/useAPIs';
import { useQuery } from 'react-query';
import { QueryKey } from 'src/models/query';
import { VideoEntityBasic } from 'src/models/directus';
import type { videosBasicGqlQuery } from 'src/modules/videos/graphql/videos-basic.query';
import type { videoDetailsGqlQuery } from 'src/modules/videos/graphql/videos-details.query';
import type { Variables } from 'src/utils/gql/query';

export const useVideosListQuery = <
  T extends typeof videosBasicGqlQuery | typeof videoDetailsGqlQuery,
>(
  query: T,
  variables?: Variables<T>,
  options?: Omit<UseQueryOptions<VideoEntityBasic[]>, 'queryKey' | 'queryFn'>,
): UseQueryResult<VideoEntityBasic[]> => {
  const apis = useAPIs();

  return useQuery(
    [...QueryKey.VideoList, query, variables],
    async () => {
      const directus = await apis.directus();

      return directus
        .query(query, variables)
        .then((d) => d.videos.filter((v) => v));
    },
    options,
  );
};
